// test1593
(1593 && 0);
